import * as icons from '~assets/svg'

export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const OWNER_NAME_MIN_LENGTH = 3

export const validateOwnerName = (value: string, minLength = OWNER_NAME_MIN_LENGTH) => {
  const trimmedNickname = value.trim()

  if (trimmedNickname.length < minLength) {
    return `Must be at least ${minLength} characters long.`
  }

  if (!/^[A-Za-z0-9._]+( [A-Za-z0-9._]+)*$/.test(trimmedNickname)) {
    return 'Can only contain letters, numbers, periods("."), and underscores("_").'
  }

  return ''
}

export const validatePetName = (value: string) => {
  if (!/^[a-zA-Z].*/.test(value)) {
    return 'Must start with an alphabet.'
  }

  if (!/^[a-zA-Z\s]*$/.test(value)) {
    return 'Can only contain alphabets and space.'
  }

  return ''
}

export const isValidIconName = (testName: string): testName is keyof typeof icons => {
  const validIconNames = Object.keys(icons)
  return validIconNames.includes(testName)
}

export const isNumber = (value: string | number) => {
  if (typeof value === 'string') {
    const parsed = Number(value)
    return !Number.isNaN(parsed)
  }
  if (typeof value === 'number') {
    return true
  }
  return false
}
